import { useTranslation } from 'react-i18next';

const steps = [
  { key: 'step1' },
  { key: 'step2' },
  { key: 'step3' },
  { key: 'step4' },
  { key: 'step5' },
];

export default function ProcessTimeline() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 lg:py-28 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-accent-600 font-label font-semibold">
            {t('process.tag')}
          </span>
          <h2 className="mt-4 md:mt-5 font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            {t('process.heading')}
          </h2>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto leading-relaxed">
            {t('process.subtitle')}
          </p>
        </div>

        <div className="relative">
          {/* Desktop horizontal line */}
          <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-px bg-background-300"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-6 lg:gap-4">
            {steps.map((step, idx) => {
              const num = idx + 1;
              return (
                <div key={step.key} className="relative flex flex-col items-center text-center">
                  {/* Number circle */}
                  <div className="relative z-10 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-foreground-900 text-white font-heading font-bold text-sm md:text-base flex-shrink-0 mb-4 md:mb-5">
                    {num}
                  </div>

                  {/* Mobile connecting line */}
                  {idx < steps.length - 1 && (
                    <div className="lg:hidden absolute top-5 left-[calc(50%+20px)] right-[calc(50%-20px)] h-px bg-background-300 md:hidden"></div>
                  )}

                  {/* Vertical line on mobile */}
                  {idx < steps.length - 1 && (
                    <div className="lg:hidden absolute top-12 left-1/2 -translate-x-1/2 w-px h-8 bg-background-300 md:hidden"></div>
                  )}

                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug mb-2">
                    {t(`process.${step.key}.title`)}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 font-body leading-relaxed max-w-xs">
                    {t(`process.${step.key}.desc`)}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}